__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "@shipbob/labor_management_mfe";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@primeuix/styled", "0.3.2", () => (__webpack_require__.e(3505).then(() => (() => (__webpack_require__(73505))))));
			register("@primeuix/utils", "0.3.2", () => (Promise.all([__webpack_require__.e(9587), __webpack_require__.e(1079)]).then(() => (() => (__webpack_require__(61079))))));
			register("@shipbob/auth", "1.7.0", () => (__webpack_require__.e(3667).then(() => (() => (__webpack_require__(13667))))));
			register("@shipbob/telemetry", "1.9.0", () => (__webpack_require__.e(1036).then(() => (() => (__webpack_require__(21036))))));
			register("axios", "1.20.0", () => (__webpack_require__.e(772).then(() => (() => (__webpack_require__(772))))));
			register("pinia", "2.3.1", () => (Promise.all([__webpack_require__.e(5899), __webpack_require__.e(5148)]).then(() => (() => (__webpack_require__(65899))))));
			register("qr-scanner", "1.4.2", () => (__webpack_require__.e(3451).then(() => (() => (__webpack_require__(53451))))));
			register("vue-axios", "3.5.2", () => (__webpack_require__.e(1021).then(() => (() => (__webpack_require__(31021))))));
			register("vue-router", "4.6.4", () => (Promise.all([__webpack_require__.e(4965), __webpack_require__.e(8352)]).then(() => (() => (__webpack_require__(74965))))));
			register("vue", "3.5.11", () => (__webpack_require__.e(2957).then(() => (() => (__webpack_require__(52957))))));
			register("vuex", "4.0.2", () => (Promise.all([__webpack_require__.e(2124), __webpack_require__.e(6143)]).then(() => (() => (__webpack_require__(82124))))));
			initExternal(63401);
			initExternal(78197);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};